import { render } from "./GoogleIcon.vue?vue&type=template&id=0a456730&scoped=true"
const script = {}

import "./GoogleIcon.vue?vue&type=style&index=0&id=0a456730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a456730"]])

export default __exports__